<template>
  <div id="app">
    <red-envelope v-if="redVisible" :info.sync="redEnvelopeInfo" :visible.sync="redVisible"></red-envelope>
    <router-view />
    <van-dialog v-model="payVisible" show-confirm-button class="qr-box" confirm-button-text="已经充值">
      <p>请使用微信扫码支付</p>
      <img :src="mobileQR" />
    </van-dialog>
    <van-dialog v-model="mobileVisible" class="qr-box">
      <template v-if="solveVisible === true">
        <p style="font-size: 20px">解决方法</p>
        <p style="padding: 10px 20px 0px 20px;font-size: 14px;">无法连接可能是因为您当前账号末绑定微信,请使用微信扫码绑定后再进入手机版电子圈</p>
        <img :src="bindQR" />
        <span @click="solveVisible = false" class="text-btn">重新扫码登录</span>
      </template>
      <template v-else>
        <p>微信扫码进入手机版</p>
        <img :src="mobileQR" alt="" />
        <span @click="solveVisible = true" class="text-btn">遇到问题？</span>
      </template>
    </van-dialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import QRCode from "qrcode";
import "signalr";
import "./utils/signalr";
import Chat from "@/api/chat";
import Bus from "@/components/Bus";
import RedEnvelope from "@/components/RedEnvelope";
import { Toast } from "vant";

export default {
  data() {
    return {
      connection: null,
      chat: null,
      sys: null,
      active: true,
      redVisible: false,
      payVisible: false,
      mobileVisible: false,
      solveVisible: false,
      payQR: "",
      bindQR: "",
      mobileQR: ""
    };
  },
  watch: {
    // token变化的时候初始化
    token: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          // 建立长连接
          this.chatInit(newValue);
          // 获取用户信息，多少能量豆多少余额，是否匿名，因为大厅需要显示
          this.getChatInfo();
          // 创建上线轮播，定时获取上线消息制造很热闹的情况
          this.getBroadcast();
          // 从后端获取有多少条通知消息调用客户端方法传给客户端
          Chat.unReadInfo().then(res => {
            this.updateInform({ key: "at", value: res.AtCount });
            this.updateInform({ key: "message", value: res.MsgCount });
          });
        }
      }
    },
    // 广播红包消息的时候状态会变，也就是红包弹窗
    redEnvelopeInfo(newValue) {
      if (newValue.redEnvelopeId) {
        this.redVisible = true;
      }
    }
  },
  computed: {
    ...mapState({
      token: state => state.token,
      inform: state => state.inform,
      userId: state => state.userId,
      messageList: state => state.messageList,
      redEnvelopeInfo: state => state.redEnvelopeInfo
    })
  },
  components: { RedEnvelope },
  methods: {
    ...mapActions(["userLogin", "getChatInfo", "getAdvert", "getConversations"]),
    ...mapMutations([
      "setChat",
      "addToMessageList",
      "withdrawMessage",
      "addSystemMessage",
      "setUserInfo",
      "updateInform",
      "setRedEnvelope",
      "addOnline",
      "setOnlineNum"
    ]),
    // 这个用户更新客户按钮显示的数字，已弃用
    informHandle(message) {
      if (this.active === false) {
        this.updateInform({ key: "message" });
      }
      if (message.ats && message.ats.find(item => item.at === this.userId)) {
        this.updateInform({ key: "at" });
      }
      if (message.ownerId && message.ownerId === this.userId) {
        this.updateInform({ key: "topic" });
      }
    },
    // 监听全局的eventbus，初始化后执行
    busListening() {
      // 由用户触发的eventbus事件，在这里监听

      // 发送消息
      Bus.$on("sendMessage", message => {
        $.connection.chatRoomHub.server.send(message);
      });
      // 撤回
      Bus.$on("withdraw", msgId => {
        $.connection.chatRoomHub.server.withdraw(msgId);
      });
      // 打开红包
      Bus.$on("openRedEnvelope", info => {
        this.setRedEnvelope(info);
        this.redVisible = true;
      });
      // 显示支付二维码
      Bus.$on("showPayQR", url => {
        this.payVisible = true;
        QRCode.toDataURL(url).then(url => {
          this.payVisible = true;
          this.mobileQR = url;
        });
      });
      // 显示支付二维码
      Bus.$on("showMobileQR", () => {
        this.mobileVisible = true;
        const bindUrl = `https://wx.bom.ai/oauth/authorize?Token=${this.token}&RedirectUrl=https://www.bom.ai/showouath`;
        const mobileUrl = "https://www.bom.ai/mobile/chat";
        QRCode.toDataURL(mobileUrl).then(url => {
          this.mobileQR = url;
        });
        console.log(bindUrl, "bindUrl");
        QRCode.toDataURL(bindUrl).then(url => {
          this.bindQR = url;
        });
      });
      // 创建私聊会话
      Bus.$on("getConversations", () => {
        this.getConversations();
      });
    },
    // 获取上线提示消息的轮播
    async getBroadcast() {
      clearTimeout(this.timmer);
      await Chat.getBroadcast().then(res => {
        if (res && res.MsgId && res.Remaining > 2) {
          this.broadcast = {
            msgId: res.MsgId || "",
            txt: `${res.CompanyName || ""}: ${res.Txt}` || ""
          };
          this.$store.commit("setBroadcast", this.broadcast);
        }
        this.timmer = setTimeout(() => {
          this.getBroadcast();
        }, 180000);
      });
    },
    // 三个Hub收到的消息在这里去处理
    broadcastMessageHandle(message, type) {
      if (message.code) {
        switch (message.code) {
          case 1002:
            this.$confirm("发送主题消息至少需要10能量豆，是否去充值？", "能量豆余额不足", {
              confirmButtonText: "去充值",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                this.$router.push({
                  path: "/wallet",
                  query: { visible: "full" }
                });
              })
              .catch(() => {});
            return true;
          default:
            Toast.fail(message.txt);
        }
      }
      if (message.id === this.userId && message.tags) {
        this.payVisible = false;
        this.mobileQR = "";
        this.getChatInfo();
      }
      switch (type) {
        // 撤回
        case "withdraw":
          this.withdrawMessage(message.msgId);
          break;
        // 红包
        case "redEnvelope":
          this.addToMessageList({ message, type });
          this.setRedEnvelope(message);
          this.visible = true;
          break;
        // 静默输出错误消息
        case "quietError":
          console.error(message, type);
          break;
        // 上线提示
        case "online":
          this.onlineHandle(message);
          break;
        // 弹窗提示的系统错误
        case "error":
          this.$toast(message.txt);
          break;
        case "reload":
          location.reload();
          break;
        // 私聊消息大厅消息走这里
        default:
          this.addToMessageList({ message });
          this.informHandle(message);
          Bus.$emit("broadcast", message);
      }
    },
    connectErrorHandle() {
      this.$confirm("与服务器断开连接，是否重连？", "网络错误", {
        confirmButtonText: "连接",
        showCancelButton: false,
        type: "warning"
      })
        .then(() => {
          location.href = "";
        })
        .catch(() => {});
    },
    // 上线消息的列表
    onlineHandle(message) {
      this.addOnline(message);
      this.setOnlineNum(message.onlineCount);
    },
    // 使用token创建ws连接
    chatInit(token) {
      $.connection.hub.stop();
      Bus.$off();
      $.connection.hub.url = `${process.env.VUE_APP_CHAT_URL}/signalr`;
      this.chat = $.connection.chatRoomHub;
      this.sys = $.connection.systemHub;
      this.conversa = $.connection.chatConversationHub;
      $.connection.chatRoomHub.client.broadcastMessage = (message, type) => {
        this.broadcastMessageHandle(message, type);
      };
      $.connection.systemHub.client.broadcastMessage = (message, type) => {
        this.broadcastMessageHandle(message, type);
      };
      $.connection.chatConversationHub.client.broadcastMessage = (message, type) => {
        this.broadcastMessageHandle(message, type);
      };
      $.connection.hub.disconnected(() => {
        if (process.env.NODE_ENV !== "development") {
          console.log("hub disconnected");
          this.connectErrorHandle();
        }
      });
      $.connection.hub.qs = { token: token, type: "pc" };
      $.connection.hub
        .start()
        .done(() => {
          // 创建连接成功更新状态，私聊才可以获取历史记录
          this.$store.commit("setHubStatus");
          this.busListening();
          Bus.$emit("getConversations");
        })
        .fail(error => {
          this.connectErrorHandle();
          console.log(error, "fail");
        });
    },
    // ERP外部点击按钮触发
    clickSideBtnHandle(event) {
      const routerDict = {
        at: {
          path: `/user`,
          query: {
            type: "AT",
            id: this.userId
          }
        },
        message: {
          path: "/"
        }
      };
      const data = event.data;
      this.active = data.active;
      this.$router.push(routerDict[data.type]);
      this.updateInform({ key: data.type, value: 0 });
    },
    clickMessageHandle(message) {
      if (message.redEnvelopeId) {
        this.redVisible = true;
        this.setRedEnvelope(message);
      } else {
        this.$router.push({
          path: "/detail",
          query: { id: message.reply || message.msgId }
        });
      }
    }
  },
  mounted() {
    if (process.env.NODE_ENV === "development") {
      this.userLogin({ account: "AG", password: "znl123456" });
    } else {
      this.userLogin();
    }
    window.addEventListener("clickSideBtn", event => {
      this.clickSideBtnHandle(event);
    });
    window.addEventListener("clickMessage", event => {
      this.clickMessageHandle(event.data);
    });
    window.addEventListener("console", event => {
      this.broadcastMessageHandle(event.data);
    });

    // 用于控制台模拟

    // window.dispatchEvent(new CustomEvent("mock-chat"));
    // window.addEventListener("mock-chat", e => {
    //   console.log(e, "e");
    //   var Mock = require("mockjs");
    //   setInterval(() => {
    //     Bus.$emit("sendMessage", { txt: Mock.Random.cparagraph() });
    //   }, e.data.time || 100);
    // });
  }
};
</script>
